import { AnalyticsBrandSettings, AnalyticsEventData } from 'idt-analytics-api/models';
import { AnalyticsEcommerceHelpersOysho } from '../helpers/brand-analytics-ecommerce.helpers.oy';
import { pageTypes } from '../helpers/brand-analytics-page-views.helpers.oy';
import { getDefaultAnalytics, getDefaultPageView } from '../helpers/events.helper';
import { AnalyticsGTMSettings, DefaultAnalyticsSettings, EcommerceEvent, isPageViewEvent } from 'analytics-api';
import { AnalyticsOyshoEventDataHelpers } from '../helpers/brand-analytics-event-data.helpers.oy';
import { AnalyticsOyshoEventsTransformer } from '../helpers/brand-analytics-events.transformer.oy';

export const GenericEvents: AnalyticsBrandSettings = {
  pageView(data: AnalyticsEventData): AnalyticsGTMSettings | undefined {
    const { componentData, helpers, context } = data;
    const slug = componentData?.slug;
    const isInfoFromComponent = componentData?.fromComponent;
    let settingsGTM: AnalyticsGTMSettings | undefined;

    if (isDefined(slug)) {
      const slugInfo = pageTypes.get(slug);
      const hasToUseInfoFromComponent = pageTypes.get(slug)?.isFromComponent;
      let dimensions = slugInfo?.dimensions || [];
      const isHandledByComponent = isInfoFromComponent && hasToUseInfoFromComponent;
      const isHandledByPage = !isInfoFromComponent && !hasToUseInfoFromComponent;
      dimensions = [...dimensions, '1', '2', '11', '12', '92', '175', '10', '38', '55', '59', '68', '73', '88', '89', '136', '174', '180', '200'];

      if (isHandledByComponent || isHandledByPage) {
        const eventSettings: DefaultAnalyticsSettings = getDefaultPageView(componentData?.pageViewType ?? 'pageview');
        settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
        if (isPageViewEvent(settingsGTM)) {
          settingsGTM.page.pageTitle = typeof slugInfo?.pageTitle === 'function' ? slugInfo.pageTitle(data) : slugInfo?.pageTitle;
        }
        settingsGTM.ecommerce = slugInfo?.ecommerce
          ? AnalyticsEcommerceHelpersOysho.getEcommerceInfo(slugInfo.ecommerce, componentData, context) : undefined;
        if (isDefined(helpers)) {
          settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
        }
      }
    }

    return settingsGTM;
  },

  endPage(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    let category = '';
    if (isDefined(componentData.slug)) {
      category = pageTypes.get(componentData.slug)?.pageType ?? '';
    }

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'navegacion', category, 'final_pagina');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  /** Evento para lanzar una impresión de una página */
  impression(data: AnalyticsEventData): EcommerceEvent {
    const { componentData, context } = data;
    const eventSettings: EcommerceEvent = {
      event: 'impression',
      context: {
        isCMS: true
      },
      ecommerce: AnalyticsEcommerceHelpersOysho.getEcommerceImpressions(componentData, context)
    };
    return eventSettings;
  },

  /** Evento en caso de hacer click sobre un banner en cualquiera de las páginas */
  clickBanner(data: AnalyticsEventData): AnalyticsGTMSettings | undefined {
    const { componentData } = data;
    if (!isDefined(componentData?.location)) { return undefined; }
    const url = AnalyticsEcommerceHelpersOysho.parseUrl(componentData.url);
    const page = pageTypes.get(componentData.location)?.pageType;
    if (isDefined(page)) {
      const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', page, 'click_banner', url);
      return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    }
    return undefined;
  }
};
